import { StepperStep } from '@/components/NewGeneralDialog/DialogStepper';
import { createContext } from 'react';

interface GeneralDialogContextType {
  steps?: StepperStep[];
  activeStepIndex: number;
  isStepperVisible: boolean;
  moveForward: () => void;
  moveBackward: () => void;
  hideStepper: () => void;
  showStepper: () => void;
  moveToStep: (stepIndex: number) => void;
}

export const GeneralDialogContext = createContext<GeneralDialogContextType>({
  steps: [],
  activeStepIndex: 0,
  isStepperVisible: true,
  moveForward: () => null,
  moveBackward: () => null,
  hideStepper: () => null,
  showStepper: () => null,
  moveToStep: () => null,
});
